export default __webpack_public_path__ + "static/identity-mock-m4-ad48d612a22ee0dbf725520fc4cf450a.png";